import Vue from 'vue'

export async function getReservas(context, [access_token, busquedafechas, busquedacliente, busquedaproveedor, busquedaactividad, busquedaestado, busquedadesde, busquedahasta, showload]) {
    try {
        if (busquedaproveedor != null && busquedaproveedor.id == 1) {
            busquedaproveedor = null;
        }
        if (showload) {
            context.commit('setLoading', true, { root: true })
        }
        const response = await Vue.axios({
            method: 'POST',
            url: '/buscarreservasactividades',
            headers: {
                //  'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                busquedafechas: busquedafechas,
                busquedacliente: busquedacliente,
                busquedaproveedor: busquedaproveedor,
                busquedaactividad: busquedaactividad,
                busquedaestado: busquedaestado,
                busquedadesde: busquedadesde,
                busquedahasta: busquedahasta


            }
        })
        context.commit('res/setReservas', response.data, { root: true })
    } catch (e) {
    } finally {
        if (showload) {
            context.commit('setLoading', false, { root: true })
        }
    }
}

export async function getReservaxid(context, [access_token, id, showload]) {
    try {
        if (showload) {
            context.commit('setLoading', true, { root: true })
        }
        const response = await Vue.axios({
            method: 'POST',
            url: '/busquedareservaxid',
            headers: {
                //  'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                id: id,
            }
        })
        return response.data;
        //context.commit('res/setReservas', response.data, { root: true })
    } catch (e) {
    } finally {
        if (showload) {
            context.commit('setLoading', false, { root: true })
        }
    }
}


export async function getReservas22(context, [access_token, busquedafechas, busquedacliente, busquedaproveedor, busquedaactividad, busquedaestado, busquedadesde, busquedahasta, showload]) {
    try {
        if (busquedaproveedor != null && busquedaproveedor.id == 1) {
            busquedaproveedor = null;
        }
        if (showload) {
            context.commit('setLoading', true, { root: true })
        }
        const response = await Vue.axios({
            method: 'POST',
            url: '/buscarreservasactividades',
            headers: {
                //  'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                busquedafechas: busquedafechas,
                busquedacliente: busquedacliente,
                busquedaproveedor: busquedaproveedor,
                busquedaactividad: busquedaactividad,
                busquedaestado: busquedaestado,
                busquedadesde: busquedadesde,
                busquedahasta: busquedahasta


            }
        })
        context.commit('res/setReservas22', response.data, { root: true })
    } catch (e) {
    } finally {
        if (showload) {
            context.commit('setLoading', false, { root: true })
        }
    }
}



export async function updateReserva(context, [access_token, reserva, materiales, tarifas]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'PATCH',
            url: '/reservasactividades/' + reserva.id,
            headers: {
                //'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },

            data: {
                reserva: reserva,
                materiales: materiales,
                tarifas: tarifas
            }
        })
        if (response.status == 200) {
            context.commit('res/actListReservas', response.data, { root: true })
            return response.data;
        }
    } catch (e) {

    } finally {
        context.commit('setLoading', false, { root: true })

    }
}





export async function crearReserva(context, [access_token, reserva, cliente, materiales, tarifas]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/reservasactividades',
            headers: {
                //'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                reserva: reserva,
                cliente: cliente,
                materiales: materiales,
                tarifas: tarifas
            }
        })
        return response.data
        /* if (response.status == 200) {
             context.commit('res/actListReservas', response.data, { root: true })
         }*/
    } catch (e) {

    } finally {
        context.commit('setLoading', false, { root: true })
    }
}

export async function cambiarEstado(context, [access_token, id, estado_id]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/cambiarestado',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                id: id,
                estado_id: estado_id,
            }
        })

        if (response.status == 200) {
            context.commit('res/actEstadoListReservas', response.data, { root: true })
        }
    } catch (e) {

    } finally {
        context.commit('setLoading', false, { root: true })
    }
}

export async function cambiarPago(context, [access_token, id, pago, forma]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/cambiarpago',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                id: id,
                pago: pago,
                formadepago: forma
            }
        })

        if (response.status == 200) {
            context.commit('res/actPagoListReservas', response.data, { root: true })
        }
    } catch (e) {

    } finally {
        context.commit('setLoading', false, { root: true })
    }
}


export async function deleteReserva(context, [access_token, id]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/reservadelete',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                id: id,
            }
        })


        if (response.status == 200) {
            context.commit('res/actDeleteListReservas', id, { root: true })
        }
    } catch (e) {

    } finally {
        context.commit('setLoading', false, { root: true })
    }
}




export async function getStockMateriales(context, [access_token, fecha, materiales]) {
    try {
        const response = await Vue.axios({
            method: 'POST',
            url: '/getstockmateriales',
            headers: {
                //'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                fecha: fecha,
                materiales: materiales,
            }
        })

        if (response.status == 200 || response.status == 201) {
            return response.data;
        }

    } catch (e) {
        return null;

    }
}




